
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

/**
 * Fetch all newsletter subscribers from the database
 */
export const fetchNewsletterSubscribers = async () => {
  try {
    const { data, error } = await supabase
      .from("newsletter_subscribers")
      .select("*")
      .order("created_at", { ascending: false });

    if (error) throw error;
    return { subscribers: data || [], error: null };
  } catch (error) {
    console.error("Error fetching newsletter subscribers:", error);
    return { subscribers: [], error: error.message };
  }
};

/**
 * Toggle subscriber active status
 */
export const toggleSubscriberStatus = async (subscriberId: string, isActive: boolean) => {
  try {
    const { data, error } = await supabase
      .from("newsletter_subscribers")
      .update({ is_active: isActive, updated_at: new Date().toISOString() })
      .eq("id", subscriberId)
      .select()
      .single();

    if (error) throw error;
    return { subscriber: data, error: null };
  } catch (error) {
    console.error("Error updating subscriber status:", error);
    return { subscriber: null, error: error.message };
  }
};

/**
 * Delete a subscriber
 */
export const deleteSubscriber = async (subscriberId: string) => {
  try {
    const { error } = await supabase
      .from("newsletter_subscribers")
      .delete()
      .eq("id", subscriberId);

    if (error) throw error;
    return { error: null };
  } catch (error) {
    console.error("Error deleting subscriber:", error);
    return { error: error.message };
  }
};

/**
 * Send newsletter to subscribers
 */
export const sendNewsletter = async (subject: string, content: string) => {
  try {
    const response = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/send-newsletter`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`
      },
      body: JSON.stringify({
        subject,
        content,
        automated: false
      }),
    });

    const result = await response.json();
    
    if (!result.success) {
      throw new Error(result.message || "Failed to send newsletter");
    }
    
    return { result, error: null };
  } catch (error) {
    console.error("Error sending newsletter:", error);
    return { result: null, error: error.message };
  }
};
